import { FC } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import {
  LINKAREER_BIZ_DOMAIN,
  LINKAREER_CBT_DOMAIN,
  LINKAREER_DOMAIN,
} from 'src/app.core/linkareer/constant/urls';

const getCurrentPageUrl = (fallbackPath: string) => {
  if (typeof window !== 'undefined') return window.location.href;
  return `${LINKAREER_CBT_DOMAIN}${fallbackPath}`;
};

const UserLoginMenu: FC = () => {
  const router = useRouter();
  const currentPath = router.asPath;
  const nextUrl = getCurrentPageUrl(currentPath);
  const loginHref = `https://${LINKAREER_DOMAIN}/login?next=${encodeURIComponent(nextUrl)}`;

  return (
    <StyledWrapper>
      <a href={loginHref}>개인회원</a>
      <a className="corporate" href={`${LINKAREER_BIZ_DOMAIN}/login`}>
        기업서비스
      </a>
    </StyledWrapper>
  );
};

export default UserLoginMenu;

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  a {
    font-size: 14px;
    color: #333;
    border: none;
    outline: none;
    background: transparent;
    cursor: pointer;
  }
  .corporate {
    width: 92px;
    height: 31px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #01a0ff;
    border: solid 1px #01a0ff;
    border-radius: 14px;
  }
`;
